import React, { useContext } from 'react';
import useFeatures from '../../hooks/useFeatures';
import { AirDropContext } from '../../../utils/AirDropProvider';
import './Logo.scss';
import useDefaultHomeCountryCode from '../../hooks/useDefaultHomeCountryCode';
import SvgIcon from '../../molecules/SvgIcon/SvgIcon';

function Logo() {
  const { isChannels, isChannelsAlt, isTurbo, isPDotCom } = useFeatures();
  const { logoTreatment } = useContext(AirDropContext);
  const { logoRedirectUrl } = useDefaultHomeCountryCode();

  const renderLogo = () => {
    let logoName = '';
    if (isChannels || isChannelsAlt || isTurbo) {
      logoName = 'PPLUSLOGO';
    }
    if (isPDotCom) {
      logoName = 'PDOTCOMLOGO';
    }
    if (logoTreatment === 'reskin') {
      logoName = 'RESKINLOGO';
    }
    if (logoRedirectUrl() !== '') {
      return (
        <a href={logoRedirectUrl()} className="pearson-logo__wrapper">
          <SvgIcon name={logoName} />
        </a>
      );
    }
    return (
      <div className="pearson-logo__wrapper">
        <SvgIcon name={logoName} />
      </div>
    );
  };

  return renderLogo();
}

export default Logo;
